var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isClickable) { ;
__p += '\n  <button type="button" class="CDB-Widget-listItemInner CDB-Widget-listButton CDB-Widget-listButton--withBorder js-button">\n';
 } else { ;
__p += '\n  <div class="CDB-Widget-listItemInner CDB-Widget-listItemInner--withBorders">\n';
 } ;
__p += '\n  <div class="CDB-Widget-contentSpaced CDB-Widget-contentSpaced--topAligned CDB-Widget-contentSpaced--start">\n    <em class="CDB-Shape-dot CDB-Widget-listDot"></em>\n    ';
 if (itemsCount > 0) { ;
__p += '\n      <div class="CDB-Widget-contentFull">\n        <p class="CDB-Widget-textSmall CDB-Widget-textSmall--upper CDB-Widget-textSmall--bold" title="' +
__e( items[0][1] ) +
'">' +
__e( items[0][1] ) +
'</p>\n        ';
 if (itemsCount > 2) { ;
__p += '\n          <dl class="CDB-Widget-inlineList">\n          ';
 for (var i = 1, l = itemsCount; i < l; i++) { ;
__p += '\n            <div class="CDB-Widget-inlineListItem CDB-Widget-textSmaller CDB-Widget-textSmaller--noEllip">\n              <dd class="CDB-Widget-textSmaller--bold CDB-Widget-textSmaller--dark u-rSpace" title="' +
__e( items[i][1] ) +
'">' +
__e( items[i][1] ) +
'</dd>\n              <dt title="' +
__e( items[i][0] ) +
'">' +
__e( items[i][0] ) +
'</dt>\n            </div>\n          ';
 } ;
__p += '\n          </dl>\n        ';
 } else if (itemsCount === 2) { ;
__p += '\n          <dl class="CDB-Widget-textSmaller CDB-Widget-textSmaller--noEllip u-tSpace">\n            <dd class="CDB-Widget-textSmaller--bold CDB-Widget-textSmaller--dark u-rSpace" title="' +
__e( items[1][1] ) +
'">' +
__e( items[1][1] ) +
'</dd>\n            <dt title="' +
__e( items[1][0] ) +
'">' +
__e( items[1][0] ) +
'</dt>\n          </dl>\n        ';
 } ;
__p += '\n      </div>\n    ';
 } ;
__p += '\n  </div>\n';
 if (isClickable) { ;
__p += '\n  </button>\n';
 } else { ;
__p += '\n  </div>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/list/item-template.tpl
// module id = 874
// module chunks = 2 3